/**
 * <featured-product-info> — variant switching for the "Featured this week"
 * band, sections/featured-product.liquid.
 *
 * Without it the size pills were plain radios and the form kept the variant the
 * band first rendered, so picking L added the S the page loaded with (or bumped
 * an S already in the cart). ProductInfo in section-product.js does the job on
 * the PDP and in both quick adds, and this reuses it with two differences.
 *
 * WHICH SECTION IS RE-REQUESTED
 * ProductInfo asks the product URL for its own section with the checked option
 * values. This band cannot be asked that way: it lives on a collection template
 * and features a product picked in settings or on the team entry, so the
 * product URL has no section by this id. The quick-add drawer section is a
 * render target that draws the same buy card for any product at that product's
 * URL, so it is what gets requested, and ProductInfo rewrites its ids to ours.
 *
 * WHY ADD TO CART IS NOT SWAPPED WHOLESALE
 * The drawer draws its buttons with its own icons. This band's come from its
 * section settings — button_icon, button_icon_image, the hover swap — which a
 * render target cannot see, so taking its region would replace the merchant's
 * icon with the drawer's. Only the state crosses over: the variant id, whether
 * the button is enabled, and its label ("Sold out").
 */

import { ProductInfo } from '@theme/product-info';

/** sections/quick-add-drawer.liquid — see the header above for why this one. */
const RENDER_SECTION_ID = 'quick-add-drawer';

if (!customElements.get('featured-product-info')) {
  customElements.define(
    'featured-product-info',
    class FeaturedProductInfo extends ProductInfo {
      get renderSectionId() {
        return RENDER_SECTION_ID;
      }

      /**
       * Copies the new variant's add-to-cart state onto this band's own button.
       * @param {Document} html
       */
      updateAddToCart(html) {
        const containerId = `add-to-cart-container-${this.dataset.section}`;
        const source = html.getElementById(containerId);
        const destination = this.querySelector(`[id="${containerId}"]`);
        if (!source || !destination) return;

        const sourceInput = source.querySelector('input[name="id"]');
        const input = destination.querySelector('input[name="id"]');
        if (sourceInput && input) input.value = sourceInput.value;

        const sourceButton = source.querySelector('[type="submit"]');
        const button = destination.querySelector('[type="submit"]');
        if (!sourceButton || !button) return;

        button.disabled = sourceButton.disabled;
        // The button is kept, not replaced, so it still carries the lock from
        // lockAddToCart. Clearing it here stops unlockAddToCart restoring the
        // previous variant's state over the new one.
        button.removeAttribute('data-variant-pending');

        const sourceLabel = sourceButton.querySelector('.milb-button__label');
        const label = button.querySelector('.milb-button__label');
        if (sourceLabel && label) label.textContent = sourceLabel.textContent;
      }
    },
  );
}
